import AuthorizationWrapper from "@mds/common/wrappers/AuthorizationWrapper";

/**
 * @deprecated
 * This file has a somewhat updated version in common. 
 * For consistency and maintenance, using that version here.
 * If adding a new use case, import should refer to the common version.
 */
export default AuthorizationWrapper;